import { render } from "./MaterialsModalPainter.vue?vue&type=template&id=5eabe8f2"
import script from "./MaterialsModalPainter.vue?vue&type=script&lang=js"
export * from "./MaterialsModalPainter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__